import React, { type FC } from 'react';

import { PageSegmentLoadStart } from '@confluence/browser-metrics/entry-points/PageSegmentLoadStart';

import type { ContentTypesHeaderProps } from '../src/ContentTypesHeader';
import { OBJECT_HEADER_SEGMENT_METRIC } from '../src/perf.config';
import { ContentTypesHeaderLoader } from '../src/ContentTypesHeaderLoader';

export const ContentTypesHeader: FC<ContentTypesHeaderProps> = (props) => (
	<>
		<PageSegmentLoadStart metric={OBJECT_HEADER_SEGMENT_METRIC} />
		<ContentTypesHeaderLoader {...props} />
	</>
);

export type { ContentActions } from '../src/ContentTypesHeader';
